module.exports = __webpack_public_path__ + "media/images/nav/icon_12-d982ec2cf41159870684713f8838a2f6.svg";